import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import IMG_SLIDE_1 from '../../assets/images/example_slide_image.png';
import ICON_ARROW_SLIDE_LEFT from '../../assets/images/icon_arrow_slide_left.svg';
import ICON_ARROW_SLIDE_RIGHT from '../../assets/images/icon_arrow_slide_right.svg';
import IMG_COMMUNITY from '../../assets/images/image_community.png';
import IMG_SHIPPING from '../../assets/images/image_shipping.png';
import IMG_SLIDE_2 from '../../assets/images/IMG_SLIDE_2.png';
import IMG_SLIDE_3 from '../../assets/images/IMG_SLIDE_3.png';
import IMG_SLIDE_4 from '../../assets/images/IMG_SLIDE_4.png';
import IMG_SLIDE_5 from '../../assets/images/IMG_SLIDE_5.png';
import IMG_SLIDE_6 from '../../assets/images/IMG_SLIDE_6.png';
import IMG_SLIDE_7 from '../../assets/images/IMG_SLIDE_7.jpg';
import IMG_SLIDE_8 from '../../assets/images/IMG_SLIDE_8.jpg';
import IMG_SLIDE_9 from '../../assets/images/IMG_SLIDE_9.jpg';
import IMG_SLIDE_10 from '../../assets/images/IMG_SLIDE_10.jpg';
import IMG_SLIDE_11 from '../../assets/images/IMG_SLIDE_11.jpg';
import IMG_SLIDE_12 from '../../assets/images/IMG_SLIDE_12.jpg';
import './LandingCarouselContent.css';

const CarouselArrow = ({ direction, onClick, src }) => (
  <img
    className='carousel-arrow'
    alt={direction === 'left' ? 'Previous' : 'Next'}
    src={src}
    onClick={onClick}
  />
);

CarouselArrow.propTypes = {
  direction: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  src: PropTypes.string.isRequired,
};

const CarouselIndicators = ({ slides, activeIndex, onChange }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
      margin: '16px 0',
    }}
  >
    {slides.map((_, index) => (
      <div
        key={index}
        className={`carousel-indicator ${index === activeIndex ? 'carousel-indicator-active' : 'carousel-indicator-inactive'}`}
        onClick={() => onChange(index)}
      />
    ))}
  </div>
);

CarouselIndicators.propTypes = {
  slides: PropTypes.array.isRequired,
  activeIndex: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

const CarouselSlides = ({ slides, activeIndex }) => (
  <div className='carousel-slides-container'>
    {slides.map((image, index) => (
      <div
        key={index}
        className={`carousel-slide ${index === activeIndex ? 'carousel-slide-active' : 'carousel-slide-inactive'}`}
      >
        <img src={image} alt={`Slide ${index + 1}`} className='carousel-slide-image' />
      </div>
    ))}
  </div>
);

CarouselSlides.propTypes = {
  slides: PropTypes.array.isRequired,
  activeIndex: PropTypes.number.isRequired,
};

const FeatureCard = ({ image, title, features, additionalClass }) => (
  <div className='feature-card'>
    <img className={`feature-image ${additionalClass}`} alt={title} src={image} />
    <div className='feature-content'>
      <b className='feature-title'>{title}</b>
      <div className='feature-list'>
        <ul>
          {features.map((feature, index) => (
            <li key={index}>{feature}</li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

FeatureCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  features: PropTypes.arrayOf(PropTypes.string).isRequired,
  additionalClass: PropTypes.string.isRequired,
};

const images = [
  IMG_SLIDE_1,
  IMG_SLIDE_2,
  IMG_SLIDE_3,
  IMG_SLIDE_4,
  IMG_SLIDE_5,
  IMG_SLIDE_6,
  IMG_SLIDE_7,
  IMG_SLIDE_8,
  IMG_SLIDE_9,
  IMG_SLIDE_10,
  IMG_SLIDE_11,
  IMG_SLIDE_12,
];
const LandingCarouselContent = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prevSlide) => (prevSlide === images.length - 1 ? 0 : prevSlide + 1));
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const handlePrev = () => {
    setActiveSlide((prevSlide) => (prevSlide === 0 ? images.length - 1 : prevSlide - 1));
  };

  const handleNext = () => {
    setActiveSlide((prevSlide) => (prevSlide === images.length - 1 ? 0 : prevSlide + 1));
  };

  const featuresData = [
    {
      image: IMG_COMMUNITY,
      title: 'Community',
      features: [
        'พื้นที่ปลอดภัยในการซื้อขายสินค้า',
        'ช่วยลดภาวะสินค้าหมดอายุ',
        'เป็นพื้นที่กระจายสินค้านวัตกรรม',
      ],
      additionalClass: 'community-image',
    },
    {
      image: IMG_SHIPPING,
      title: 'Easy Shipping',
      features: [
        'ไม่ต้องเดินทางไปส่งสินค้า',
        'ระบบขนส่งเข้ารับสินค้าทุกวัน',
        'คำนวนค่าขนส่งอัตโนมัติ',
      ],
      additionalClass: 'shipping-image',
    },
  ];

  return (
    <div className='landing-carousel-content'>
      <div className='carousel-container'>
        <div className='carousel-header-container'>
          <b className='carousel-title'>ระบบจัดการคำสั่งซื้อที่ง่ายที่สุดสำหรับคุณ</b>

          <div className='carousel-controls'>
            <CarouselArrow direction='left' onClick={handlePrev} src={ICON_ARROW_SLIDE_LEFT} />
            <CarouselSlides slides={images} activeIndex={activeSlide} />
            <CarouselArrow direction='right' onClick={handleNext} src={ICON_ARROW_SLIDE_RIGHT} />
          </div>
        </div>

        <CarouselIndicators slides={images} activeIndex={activeSlide} onChange={setActiveSlide} />

        <div className='feature-cards-container'>
          {featuresData.map((feature, index) => (
            <FeatureCard
              key={index}
              image={feature.image}
              title={feature.title}
              features={feature.features}
              additionalClass={feature.additionalClass}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LandingCarouselContent;
